/* 06 · L’édition jeune maman (Shopify : assets/obaia-section-edition-jeune-maman.js)
   Photo : rideau de haut en bas 1 800 ms. En même temps (desktop) ou juste après (mobile, photo au-dessus) :
   titre ligne par ligne, puis bouton. */
OBAIA.section('edition-jeune-maman', {
  anim: function (fx) {
    var $ = OBAIA.$;
    OBAIA.$$('[data-section="edition-jeune-maman"]').forEach(function (sec) {
      var media = $('.ed__media', sec), title = $('.ed__title', sec), btn = $('.btn', sec);
      if (fx.M && OBAIA.isMobile()) {
        fx.when(media, function (tl) { fx.reveal(tl, media, 0, { dur: 1.8 * fx.K }); });
        fx.when(title, function (tl) { var d = fx.lines(tl, title, 0.3); fx.appear(tl, btn, 0.3 + d + 0.1); });
      } else {
        fx.when(media, function (tl) {
          fx.reveal(tl, media, 0, { dur: 1.8 * fx.K });
          var d = fx.lines(tl, title, 0);
          fx.appear(tl, btn, d + 0.1);
        });
      }
    });
  }
});
